/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import DecimalNumberField from '../../components/DecimalNumber';
import { ValidateWriteoffManualPayment } from '../../assets/validation';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import PaymentAction from '../../store/actions/PaymentAction';
import ReasonModal from './reasonModal';

function ManualTransactionEdit({ itemId, openmodal, modalstatus, onCloseModal }) {
  const [payInfo, setPayInfo] = useState({});
  const [resaonStatus, setReasonStatus] = useState(false);
  const [dataValues, setDataValues] = useState({});
  const dispatch = useDispatch();
  const { manualItemData, isLoading } = useSelector((state) => state.payment);

  useEffect(() => {
    dispatch(PaymentAction.getManualPaymentItem(itemId));
  }, [dispatch]);

  useEffect(() => {
    if (manualItemData) {
      setPayInfo(manualItemData);
    }
  }, [manualItemData]);
  const title = modalstatus === 'Partial Payment' ? 'Manual Payment' : 'Write Off Payment';

  const getDirtyValues = (values, initialObject) => {
    const data = { ...values };
    const keyValues = Object.keys(data);

    const dirtyValues = keyValues.filter((keyValue) => data[keyValue] !== initialObject[keyValue]);

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete data[key];
    });
    return data;
  };

  const initialValues = {
    payment_gateway: payInfo?.payment_gateway ?? '',
    transaction_id: payInfo?.transaction_id ?? '',
    amount: payInfo?.amount ?? '',
    message: payInfo?.message ?? '',
    reason: ''
  };

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        {isLoading ? <ContentLoader /> : ''}
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={ValidateWriteoffManualPayment}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            const updateValues = getDirtyValues(values, initialValues);
            if (
              updateValues.payment_gateway ||
              updateValues.transaction_id ||
              updateValues.amount
            ) {
              setSubmitting(false);
              setDataValues(updateValues);
              setReasonStatus(true);
            } else {
              dispatch(
                PaymentAction.updateManualPayment(
                  itemId,
                  updateValues,
                  setErrors,
                  setSubmitting,
                  onCloseModal
                )
              );
            }
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title={title}
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="payment_gateway"
                    fullWidth
                    label="Payment Method"
                    name="payment_gateway"
                    // size="medium"
                    margin="normal"
                    placeholder="Enter Payment Method"
                    value={values.payment_gateway}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={errors.payment_gateway && touched.payment_gateway}
                    helperText={
                      errors.payment_gateway && touched.payment_gateway && errors.payment_gateway
                    }
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                  <TextField
                    fullWidth
                    id="transaction_id"
                    name="transaction_id"
                    label="Transaction ID"
                    placeholder="Enter Transaction ID"
                    variant="outlined"
                    margin="normal"
                    value={values.transaction_id}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, '');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={touched.transaction_id && Boolean(errors.transaction_id)}
                    helperText={touched.transaction_id && errors.transaction_id}
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                  <Field name="amount">
                    {({ field }) => (
                      <TextField
                        {...field}
                        label="Amount"
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        value={values.amount}
                        // inputProps={{
                        //   Inputcomponent: DecimalNumberField
                        // }}
                        InputProps={{
                          maxLength: 8,
                          inputComponent: DecimalNumberField
                        }}
                        onChange={(event) => {
                          field.onChange(event);
                        }}
                        onBlur={(e) => {
                          field.onBlur(e);
                        }}
                        error={touched.amount && Boolean(errors.amount)}
                        helperText={touched.amount && errors.amount}
                        required={false}
                        InputLabelProps={{ required: true }}
                      />
                    )}
                  </Field>
                  <TextField
                    fullWidth
                    id="message"
                    name="message"
                    label="Message"
                    placeholder="Enter Message"
                    multiline
                    rows={3}
                    variant="outlined"
                    margin="normal"
                    // inputProps={{
                    //   maxLength: 128
                    // }}
                    value={values.message}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={touched.message && Boolean(errors.message)}
                    helperText={touched.message && errors.message}
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                  {/* {
                   updateValues.payment_gateway ||
                   updateValues.transaction_id ||
                   updateValues.amount (
                    <TextField
                      fullWidth
                      id="rea"
                      name="reason"
                      label="Reason"
                      placeholder="Enter Reason"
                      multiline
                      rows={3}
                      variant="outlined"
                      margin="normal"
                      value={values.reason}
                      onChange={(e) => {
                        handleChange(e);
                        setReasonStatus(true);
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        const val = (e.target.value || '').replace(/\s+/gi, ' ');
                        setFieldValue(e.target.name, val.trim());
                      }}
                      error={touched.reason && Boolean(errors.reason)}
                      helperText={touched.reason && errors.reason}
                      required={false}
                      InputLabelProps={{ required: true }}
                    />
                  )} */}
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
        {resaonStatus === true ? (
          <ReasonModal
            itemId={itemId}
            open={resaonStatus}
            data={dataValues}
            onCloseModal={onCloseModal}
            onCloseReasonModal={() => {
              setReasonStatus(false);
            }}
          />
        ) : (
          ''
        )}
      </Box>
    </Modal>
  );
}
ManualTransactionEdit.propTypes = {
  modalstatus: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ManualTransactionEdit;
